var map = {
	"./customer-bg.webp": 1508,
	"./customer-img.webp": 1509,
	"./dice-img.webp": 1510,
	"./games-img.webp": 1511,
	"./lc-img.webp": 1512,
	"./lottery-img.webp": 1513,
	"./mission-bg.webp": 1514,
	"./mission-img-2.webp": 1515,
	"./mission-img.webp": 1516,
	"./mission-main-bg.webp": 1517,
	"./mobile-bg.webp": 1518,
	"./p2p-img.webp": 1519,
	"./product-bg.webp": 1520,
	"./product-main-bg.webp": 1521,
	"./sb-provider.webp": 1522,
	"./sbo-provider.webp": 1523,
	"./side-bar-bg.webp": 1524,
	"./slot-img.webp": 1525,
	"./spade-img.webp": 1526,
	"./sport-img.webp": 1527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;